// extracted by mini-css-extract-plugin
export default {"whead":"com_whead__BTCQH","upGr":"com_upGr__7XWMt","btnUp":"com_btnUp__H2cuW","ipl":"com_ipl__4yDBD","plh":"com_plh__tB0nG","lnb":"com_lnb__8aYGB","phPrev":"com_phPrev__Al-D8"};